/*
 * Headers for the response history module
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, SortableListModel) {
  "use strict";

  Messenger.reqres.setHandler("topic:response:history:headers", function () {
    return new SortableListModel.headerCollection([
      {
        headerName: $.t("history.user"),
        modelAttribute: "userName",
        selectable: true,
        filterable: true,
        textField: true,
        width: "20%",
      },
      {
        headerName: $.t("history.date"),
        modelAttribute: "dateTime",
        sortable: true,
        defaultReversed: true,
        dateField: true,
        hideable: true,
      },
      {
        headerName: $.t("history.oldStatus"),
        modelAttribute: "oldStatusName",
        sortable: true,
        filterable: true,
        hideable: true,
        textField: true,
        width: "22%",
      },
      {
        headerName: $.t("history.newStatus"),
        modelAttribute: "newStatusName",
        sortable: true,
        filterable: true,
        hideable: true,
        textField: true,
        width: "22%",
      },
    ]);
  });
});
